<!-- Monitor -->
<ng-container *ngFor="let row of leftWindowPositions(); let i = index; trackBy: trackByIndex">
    <ng-container *ngFor="let position of row; let j = index">
        <svg:g [attr.transform]="'translate(' + position.x + ', ' + position.y + ')'">
            <svg:path
                class="window-left"
                d="M20 31 L0 19 L0 0 L20 12 L20 45 Z"
                [attr.fill]="'var(--window-shade-bg-2)'" />
            <svg:path
                class="window-left"
                d="M20 29 L2 18 L2 1.5 L20 12 L20 29 Z"
                [attr.fill]="position.isLit ? 'var(--window-lit-bg-1)' : 'var(--window-dark-bg-1)'" />
        </svg:g>
    </ng-container>
</ng-container>

<ng-container *ngFor="let row of rightWindowPositions(); let i = index; trackBy: trackByIndex">
    <ng-container *ngFor="let position of row; let j = index">
        <svg:g [attr.transform]="'translate(' + position.x + ', ' + position.y + ')'">
            <svg:path
                class="window-right"
                d="M20 30 L0 42 L0 24 L20 11.7 Z"
                [attr.fill]="'var(--window-shade-bg-2)'" />
            <svg:path
                class="window-right"
                d="M18 29 L0 40 L0 24 L18 13 Z"
                [attr.fill]="position.isLit ? 'var(--window-lit-bg-2)' : 'var(--window-dark-bg-2)'" />
        </svg:g>
    </ng-container>
</ng-container>
